/* eslint-disable react/forbid-dom-props */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from 'react';
import * as PropTypes from 'prop-types';
import { debounce } from 'lodash-es';
import { Constants } from '@shared/utils/constants';
import { TextField, Text, Label, mergeStyleSets } from '@fluentui/react';
import { useId } from '@fluentui/react-hooks';
export const MINIMAL_QUANTITY = 1;
export const DEBOUNCE_DURATION = 750;
const contentStyles = mergeStyleSets({
    label: {
        marginBottom: 5
    }
});
const checkIfQuantityValid = (value, maxQuantity, minQuantity)=>{
    const quantity = parseInt(value, 10);
    return quantity >= minQuantity && quantity <= maxQuantity;
};
export const SeatsPicker = ({ checkout: { items }, config: { locale }, config, setSeatNumber, disableNextButton }, context)=>{
    const { maxQuantity = Constants.Checkout.MaxQuantity, minQuantity = MINIMAL_QUANTITY, isQuantifiable, id } = items[0];
    const [numSeats, setNumSeats] = useState(items[0].quantityString);
    const maxNumSeats = Math.min(Constants.Checkout.MaxQuantity, maxQuantity);
    const handleDebounce = useRef(debounce((quantity)=>{
        disableNextButton(false);
        return setSeatNumber({
            id,
            numSeats: parseInt(quantity),
            numSeatsString: quantity
        });
    }, DEBOUNCE_DURATION)).current;
    useEffect(()=>{
        return handleDebounce.cancel();
    }, []);
    const errorMessage = isQuantifiable && !checkIfQuantityValid(numSeats, maxNumSeats, minQuantity) ? context.locParams('Number_Users_ErrorMessage', [
        minQuantity.toLocaleString(config.locale),
        maxNumSeats.toLocaleString(config.locale)
    ]) : '';
    const fallbackString = isQuantifiable ? `Number of users (${minQuantity.toLocaleString(locale)}-${maxNumSeats.toLocaleString(locale)})` : '';
    const handleQuantityChange = (_, quantity)=>{
        setNumSeats(quantity === null || quantity === void 0 ? void 0 : quantity.toString());
        const isQuantityValid = checkIfQuantityValid(quantity, maxNumSeats, minQuantity);
        /** This timeout mechanism is in place because every edit to the number of seat in the state triggers multiple
     * calls to PurchaseBlends, which results in throttling, therefore debouncing is in order.
     * Disables the next button to indicate 'state is loading' then waits 'DEBOUNCE_DURATION' before updating the store and enabling the button
     */ disableNextButton(true);
        if (isQuantityValid) {
            handleDebounce(quantity);
        }
    };
    const textLabel = context.locParams('Number_Users', [
        minQuantity.toLocaleString(locale),
        maxNumSeats.toLocaleString(locale)
    ], fallbackString);
    const textFieldId = useId('textField');
    return /*#__PURE__*/ _jsx("div", {
        className: "billing-terms mt-20",
        children: /*#__PURE__*/ _jsx("div", {
            id: "seat-count-checkout",
            children: /*#__PURE__*/ _jsx(TextField, {
                onRenderLabel: ()=>/*#__PURE__*/ _jsxs(Label, {
                        htmlFor: textFieldId,
                        className: contentStyles.label,
                        children: [
                            textLabel,
                            " ",
                            /*#__PURE__*/ _jsx(Text, {
                                className: "requiredColor",
                                children: "*"
                            })
                        ]
                    }),
                id: textFieldId,
                "data-bi-id": "seatsControl",
                "data-bi-name": "Set number of seats",
                value: numSeats,
                errorMessage: errorMessage,
                onChange: handleQuantityChange,
                "aria-label": textLabel,
                type: "number"
            })
        })
    });
};
SeatsPicker.contextTypes = {
    loc: PropTypes.func,
    locParams: PropTypes.func
};
